import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'graphicManagerHistoricTable',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:false,
  
  getURL:'graphicmanagers/historic',
  removeURL:'graphicmanagers/historic',

  sessionParams: [],

  emptyMessage: "You don't have any historic defined for this manager.",
  fields: [
    // {
    //   attributeName: 'id',
    //   label: 'Id',
    //   type: FormInputTypes.TEXT,
    //   default: '',
    //   canOrder: false,
    //   canEdit: true,
    //   canCreate: true,
    //   canFilter: false,
    //   helpText: 'Content id.',
    // },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the manifest.',
    },
    {
      attributeName: 'tags',
      label: 'Tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
      exactWidth:'100px'

    },
    {
      attributeName: 'timelineType',
      label: 'Timeline Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Time when content in.',
      exactWidth:'100px'

    },
    {
      attributeName: 'inEpoch',
      label: 'In',
      type: FormInputTypes.TIME,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      secondaryValue:'timelineType',
      helpText: 'Time when content in.',
      exactWidth:'100px'

    },
    {
      attributeName: 'outEpoch',
      label: 'Out',
      type: FormInputTypes.TIME,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      secondaryValue:'timelineType',
      helpText: 'Time when content out.',
      exactWidth:'100px'

    },
  ],
};
